export const getVouchers = ({ voucherReducer: { vouchers = [] } = {} }) => vouchers;
export const getVouchersFilter = ({ voucherReducer: { filter = {} } = {} }) => filter;
export const getVouchersCount = ({ voucherReducer: { count = 0 } = {} }) => count;


export const getCodes = ({ voucherReducer: { codes = [] } = {} }) => codes;
export const getCodesFilter = ({ voucherReducer: { code_filter = {} } = {} }) => code_filter;
export const getCodesCount = ({ voucherReducer: { code_count = 0 } = {} }) => code_count;
